/**
 * LaSalle's router paths.
 *
 * LaSalle's pages live under `/lasalle` (Rev EU's, which predate customer
 * modules, are at the root). The copied views import `routerPaths` and
 * `useOpenFileDetail` from here instead of the shell's `@/ui/router`, so every
 * link and redirect stays inside the module. Written by hand; the rest of the
 * module is copied from Rev EU by `scripts/copy-customer-module.py frontend`.
 */
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { routerPathsFor } from "@/ui/router";

export const LASALLE_BASE_PATH = "/lasalle";

export const routerPaths = routerPathsFor(LASALLE_BASE_PATH);

/** Returns a callback that opens a LaSalle file's detail page. */
export function useOpenFileDetail(): (fileId: string) => void {
    const navigate = useNavigate();
    return useCallback(
        (fileId: string) => {
            navigate(routerPaths.files.detail(fileId));
        },
        [navigate],
    );
}
